import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';// React RouterからuseHistoryをインポートします。
import styles from './Contact.module.css';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const myStyle = {
    '& .MuiInputBase-input': {
      color: '#000000',    // 入力文字の色
    },
    '& label': {
      color: '#AAAAAA', // 通常時のラベル色 
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#CCCCCC', // 通常時のボーダー色
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: '#DDDDDD',  // ホバー時のボーダー色
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#CCCCCC',    // 通常時のボーダー色(アウトライン)
      },
      '&:hover fieldset': {
        borderColor: '#DDDDDD',    // ホバー時のボーダー色(アウトライン)
      },
    },
  }

const Contact = () => {
    const [formValues, setFormValues] = useState({
        name: '',
        corporateName: '',
        email: '',
        package: '',
        content: '',
    });

    const [errors, setErrors] = useState({});
    const navigate = useNavigate(); // useNavigateフックを使用
    const location = useLocation(); // useLocationフックを追加

    

    useEffect(() => {
        // もし前のページからフォームの値が渡されたら、それでステートを更新
        if (location.state?.formValues) {
            setFormValues(location.state.formValues);
        }
    }, [location.state]);
    
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues({ ...formValues, [name]: value });
    };

  const validate = () => {
    let tempErrors = {};
    tempErrors.name = formValues.name ? '' : '氏名を入力してください。';
    tempErrors.corporateName = formValues.corporateName ? '' : '会社名を入力してください。';
    tempErrors.email = formValues.email ? (/\S+@\S+\.\S+/.test(formValues.email) ? '' : 'メールアドレスの形式が正しくありません。') : 'メールアドレスを入力してください。';
    tempErrors.package = formValues.package ? '' : 'ご希望のパッケージを選択してください。';
    setErrors(tempErrors);
    return Object.values(tempErrors).every(x => x === '');
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      // Use navigate to go to the confirmation page, passing formValues as state
      navigate('/confirm', { state: { formValues } });
    }
  };

  return (
    <section className={styles.contact_area}>
        <h2>CONTACT US</h2>
        <div className={styles.contact_discription}>
            <p className={styles.text}>下記のお問い合わせフォームよりご希望のプランをご記入の上、お問い合わせ下さい。<br/>
            担当者より1営業日以内にご連絡させていただきます。</p>
        </div>
        <div className={styles.contents}>
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit}
            >
                <TextField
                    name="name"
                    label="氏名"
                    // variant="standard"
                    value={formValues.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    sx={myStyle}
                />
                <TextField
                    name="corporateName"
                    label="会社名"
                    //variant="standard"
                    value={formValues.corporateName}
                    onChange={handleChange}
                    error={!!errors.corporateName}
                    helperText={errors.corporateName}
                    sx={myStyle}
                />
                <TextField
                    name="email"
                    label="メールアドレス"
                    //variant="standard"
                    value={formValues.email}
                    onChange={handleChange}
                    error={!!errors.email}
                    helperText={errors.email}
                    sx={myStyle}
                />
                <FormControl component="fieldset" error={!!errors.package}>
                    <FormLabel component="legend">ご希望のパッケージ</FormLabel>
                    <RadioGroup
                        name="package"
                        value={formValues.package}
                        onChange={handleChange}
                    >
                        <FormControlLabel value="Coding Package" control={<Radio />} label="Coding Package" />
                        <FormControlLabel value="Design Package" control={<Radio />} label="Design Package" />
                        <FormControlLabel value="Full Package" control={<Radio />} label="Full Package" />
                    </RadioGroup>
                    {errors.package && <p style={{ color: 'red', margin: '10px 0' }}>{errors.package}</p>}
                </FormControl>
                <TextField
                    name="content"
                    label="その他ご要望がございましたら、ご記入ください。"
                    multiline
                    rows={4}
                    maxRows={12}
                    //variant="standard"
                    value={formValues.content}
                    onChange={handleChange}
                    sx={myStyle}
                />
                <div className={styles.btn_wrapper}>
                    <Button type="submit" variant="contained">送信する</Button>
                </div>
            </Box>
        </div>
    </section>
  );
};

export default Contact;
